import React from "react";
import "../../components/StagesList/StagesList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const StagesList = ({ statusDetailResponse, setOpenProfile, openProfile ,GetId,openAddProfile,setOpenAddProfile}) => {
  function HandleChange(param) {
    
    GetId(param);
  }
  //console.log(statusDetailResponse);
  return (
    <div className="container-fluid">
      <div className="stagesList">
        <table>
          <tr className="stagesListHeading">
            <th>S No.</th>
            <th>Status Name</th>
            <th>Stages Name</th>
            <th>Action</th>
          </tr>
          {statusDetailResponse !== null ? (
            statusDetailResponse.map((status) => (
              <tr key={status.stageid}>
                <td>{status.stageid}</td>
                <td>{status.StatusName}</td>
                <td>{status.stagename}</td>
                <td>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: "#F1F1F1",
                    }}
                    onClick={() => {setOpenProfile(!openProfile);
                      HandleChange(status.stageid); 
                      setOpenAddProfile(false);}}
                  >
                    <EditOutlinedIcon className="icon" />
                  </button>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      marginLeft: "5px",
                      backgroundColor: "#F4616F",
                      borderColor: "#FF0000",
                    }}
                  >
                    <DeleteOutlinedIcon className="icon" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <p>empty</p>
          )}
        </table>
      </div>
    </div>
  );
};

export default StagesList;
